<template>
    <b-card no-body>
        <b-card-body>
            <h4 class="heading-1 mb-4">
                <span>{{operacao}} Feriado</span>
                <div class="float-right" v-if="this.operacao == 'Atualizar'">
                    <span class="text-primary">
                        <i
                            class="fa fa-refresh fa-lg icon-button"
                            title="Atualizar"
                            @click.stop="obterFeriado()"
                        ></i>
                    </span>
                </div>
            </h4>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <div>
                <b-row>
                    <b-col sm="12" md="6">
                        <b-form-group>
                            <label class="required">
                                Nome do Feriado
                            </label>
                            <b-form-input
                                type="text"
                                placeholder="Informe o nome do feriado"
                                v-model="nome"
                                @input.native="$v.nome.$touch()"
                                :state="$v.nome.$error ? false : null"
                            ></b-form-input>
                            <b-form-invalid-feedback>
                                O nome do feriado é obrigatório
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="3">
                    <b-form-group>
                            <label for="data" class="required">Data do Feriado</label>
                            <b-input-group>
                                <date-picker
                                    id="data"
                                    v-model="data"
                                    :config="$datePickerOptions2"
                                    v-mask="'##/##/####'"
                                    >
                                </date-picker>
                                <b-form-invalid-feedback>A data do feriado é obrigatória</b-form-invalid-feedback>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                </b-row>
            </div>
        </b-card-body>
        <b-card-footer>
            <b-button
                variant="primary"
                @click.stop="confirmarOperacao()"
                :disabled="!habilitarSalvar"
                class="mr-2">
                    <i class="fa fa-save"></i> Salvar
            </b-button>
            <b-button variant="danger" @click.stop="cancelar()" class="mr-2">
                <span> <i class="fa fa-remove"></i> Cancelar </span>
            </b-button>
        </b-card-footer>
    </b-card>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import FeriadosServicos from './FeriadosServicos'

export default {
    props:{
        operacao: String
    },
    
    data() {
        return {
            erros: [],
            nome: null,
            data: null,
            ativo: true,
        }
    },

    methods: {
        confirmarOperacao() {
            this.$swal({
                title: 'Feriado',
                html: `Confirma a 
                ${this.operacao == 'Inserir' ? 'inserção' : 'atualização'}
                    do feriado ${this.nome.toUpperCase()}?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.salvar()
                }
            })
        },

        cancelar() {
            this.erros = []
            this.$router.push({
                name: 'Feriados'
            })
        },

        salvar() {
            if(this.operacao == 'Inserir'){
                let feriadoDto = {
                    descricao: this.nome,
                    dataFeriado: this.$moment(this.data, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                    ativo: this.ativo,
                    feriadoId: this.feriadoId
                }
                this.$store.dispatch('addRequest')
                FeriadosServicos.inserir(feriadoDto).then(
                    (response) => {
                        if(response){
                            if(response.success){
                                if (this.operacao == 'Inserir') {
                                this.registroSalvoComSucesso()
                            } else {
                                this.registroSalvoComSucesso()
                            }
                        } else {
                            this.$toast.error(
                                response.errors[0],
                                'ERROR',
                                this.$toastConfig.error
                            )
                            this.erros = response.errors
                        }
                    }
                    this.$router.push({
                        name: 'Feriados'
                    })
                    this.$store.dispatch('removeRequest')
                    })
            } else {
                let feriadoDto = {
                    descricao: this.nome,
                    dataFeriado: this.$moment(this.data, 'DD/MM/YYYY').format('YYYY/MM/DD'),
                    ativo: this.ativo,
                    feriadoId: this.$route.params.feriadoId
                }
                this.$store.dispatch('addRequest')
                FeriadosServicos.atualizar(feriadoDto).then(
                    (response) => {
                        if(response){
                            if(response.success){
                                this.registroSalvoComSucesso()
                        } else {
                            this.$toast.error(
                                response.errors[0],
                                'ERROR',
                                this.$toastConfig.error
                            )
                            this.erros = response.errors
                        }
                    }
                    this.$router.push({
                        name: 'Feriados'
                    })
                    this.$store.dispatch('removeRequest')
                    })
            }
        },

        registroSalvoComSucesso() {
            this.erros = []
            this.$toast.success(
                'Feriado salvo com sucesso!',
                'OK',
                this.$toastConfig.success
            )
            this.$store.dispatch('setRecarregar', true)
            this.$router.push({
                name: 'Feriado_Detalhar',
                params: { feriadoId: this.$route.params.feriadoId}
            })
        },

        obterFeriado() {
            this.$store.dispatch('addRequest')
            FeriadosServicos.obterPorId(this.$route.params.feriadoId)
                .then((response) => {
                if (response) {
                    if (response.success) {
                        this.preencheFormulario(response.data)
                    } else {
                        this.$toast.error(
                                response.errors[0],
                                'ERROR',
                                this.$toastConfig.error
                            )
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        preencheFormulario(data) {
            if (data) {
                this.nome = data.descricao
                this.data = this.$moment(data.dataFeriado).format('DD/MM/YYYY')
                this.ativo = data.ativo
            }
        }
    },

    created() {
        if (this.operacao == 'Atualizar') {
            this.obterFeriado()
        }
    },

    computed: {
        habilitarSalvar() {
            return !this.$v.$invalid
        },

        operacao() {
            return this.$route.name == 'Feriado_Inserir' ? 'Inserir' : 'Atualizar'
        },
    },

    validations: {
        nome: {
            required
        },
        data: {
            required
        }
    },
}
</script>
